<div *ngIf="wrapped" class="form-group" [ngClass]="wrappedClass">
  <label for="{{name}}">{{label || (name | stringSpacer)}}</label>
  <input type="password" id="{{name}}" maxlength="{{maxlength}}" name="{{name}}" placeholder="{{placeholder}}" [ngClass]="class" [(ngModel)]="model"
    [attr.disabled]="disabled ? 'disabled' : null" autocomplete="{{autoComplete}}" (ngModelChange)="modelChanged($event)" />
</div>

<input *ngIf="!wrapped" type="password" id="{{name}}" maxlength="{{maxlength}}" placeholder="{{placeholder}}" [ngClass]="class" name="{{name}}"
  [(ngModel)]="model" [attr.disabled]="disabled ? 'disabled' : null" autocomplete="{{autoComplete}}" (ngModelChange)="modelChanged($event)" />
